import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Link(): Components<Theme> {
  return {
    MuiLink: {
      defaultProps: {
        underline: "hover",
      },
    },
  };
}
